import axios from 'axios';

/**
 * add
 */
export const add = data => axios.$callAPI(() => axios.post('users/', data));
/**
 * get list
 */
export const getUserList = data => axios.$callAPI(() => axios.get('users/search', { params: data }));

/**
 * get userInfo
 */
export const getUserInfo = id => axios.$callAPI(() => axios.get('/users/' + id));

/**
 * edit
 */
export const edit = (id, data) => axios.$callAPI(() => axios.put('users/' + id, data));

/**
 * 删除
 */
export const del = id => axios.$callAPI(() => axios.delete('users/' + id));
/**
 * 批量删除
 */
export const delAll = ids => axios.$callAPI(() => axios.delete('users/', { data: ids }));
/**
 * 个人中心密码修改接口
 */
export const cpassword = data => axios.$callAPI(() => axios.post('users/cpassword/', data));

/**
 * 个人信息修改
 */
export const putMyInfo = data => axios.$callAPI(() => axios.put('users//self/', data));
